// Component disabled on purpose

export const HantStandaloneAffiliateGallery = (props: any) => <></>;
